<template>
  <div id="drugordersInbox">
  <MdTitle :Text="`${$t('DrugOrderReturnedItems.Title')} -  
                   ${this.medications.drugName} - ${this.medications.form}
                   <span class='highlightInTitle blueTitle text-uppercase'>${medications.internalStatusTranslated}</span>`" />

    <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly || !CanReturnedItem">
        <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
        <div class="flex-grow-1">
            <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
        </div>
    </div>   
   
    <div class="grid-margin stretch-card">
			<div class="card activeCard">
			<div class="card-body">	     
			<div class="d-flex align-items-start justify-content-between">
				<h6 v-b-toggle="'OrdertoFill'" class="card-title flex-grow lower-line text-truncate"> {{ $t('DrugOrdersInboxFill.OrderToReturnItems') }}</h6>
        <i class="mdi mdi-arrow-right-drop-circle text-corporate" style="cursor: pointer" v-on:click="GotoMedByBox"></i>
			</div>

			<div class="float-left col-md-3 text-muted p-item">
				<small>{{ $t('Medication.DrugName') }}</small><br>
				<b>{{this.medications.drugName}}</b><br>
        <div v-if="this.medications.isHighAlert" class="DrugOrderType doiHighAlert">
            {{ $t('modalMarsMed.isHighAlert') }}
        </div>
        <div v-if="this.medications.isLookAlikeSoundAlike" class="DrugOrderType dotLASA">
           {{ $t('DrugOrdersInboxFill.LASA') }}
        </div>
        <div :class="this.medications.mode === 'STAT' ? 'DrugOrderType dotSTAT' : 'DrugOrderType'">
           {{this.medications.mode}}
        </div>
         <div v-if="this.medications.drugTypeCode" v-bind:class=" (this.medications.drugTypeCode === 'CD' || this.medications.drugTypeCode === 'SCD') ? 'DrugOrderType dotCD-SCD' : 'DrugOrderType'">
            {{this.medications.drugType}}
        </div>               
			</div>

			<div class="float-left col-md-3 text-muted p-item" v-if="this.medications.activeIngred">
				<small>{{ $t('Shared.activeIngredients') }}</small><br>
				<b>{{this.medications.activeIngred}}</b>
			</div>

			<div class="float-left col-md-3 text-muted p-item" v-if="this.medications.drugCode">
				<small>{{ $t('drug.DrugCode') }}</small><br>
				<b>{{this.medications.drugCode}}</b>
			</div>

      <div class="float-left col-md-3 text-muted p-item" v-if="this.medications.quantityOrdered">
				<small>{{ $t('modalMarsMed.QuantityOrdered') }}</small><br>
				<b>{{this.medications.quantityOrdered}} {{this.medications.form}}</b>
			</div>
			</div>
		</div>		
	</div>
  
  <div v-if="CanReturnedItem">

    <MdTitle v-bind:Text="$t('DrugOrderReturnedItems.FilledInformation')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" />

       <div class="groupscroll">
            <div v-if="showEmptyRecords" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                <div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div>
            </div>
           <div v-for="(item, index) in OrderDetail" :key="index" class="w-100">
                <b-row class="groupingRow">
                    <b-col lg="2" md="2" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrderReturnedItems.QTYtoReturned')"
                            v-bind:TypeProp="'number'"
                            v-bind:Min="'0'" 
                            v-bind:Max="`${item.qtyFilled}`"
                            v-bind:isReadOnly="isReadOnly || item.qtyFilled === 0" 
                            v-bind:Name="'QTYToReturn'+index"               
                            v-model.number="item.qtyToReturn"
                            v-on:change="onChangeReturnQTY('QTYToReturn'+index,item)"
                            v-bind:Id="'QTYToReturn'+index">                                     
                        </MdEdit>        
                    </b-col>
                    <b-col lg="2" md="2" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrderReturnedItems.Remarks')"
                            v-bind:TypeProp="'text'" 
                            v-bind:Name="'Remarks'"   
                            v-bind:isReadOnly="isReadOnly || item.qtyFilled === 0"            
                            v-model="item.remarks"               
                            v-bind:Id="'input_Remartks'+index">                                     
                        </MdEdit>
                    </b-col>                    
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrderReturnedItems.Location')"
                            v-bind:TypeProp="'text'"
                            v-bind:isReadOnly="true" 
                            v-bind:Name="'Location'"               
                            v-model="item.locationDescription"               
                            v-bind:Id="'input_location'+index">                                     
                        </MdEdit>        
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrderReturnedItems.QTYtofilled')"
                            v-bind:TypeProp="'number'"
                            v-bind:isReadOnly="true" 
                            v-bind:Name="'QTYtofill'"               
                            v-model="item.qtyFilled"               
                            v-bind:Id="'input_QTYtofill'+index">                                     
                        </MdEdit>        
                    </b-col>
                    <b-col lg="2" md="2" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrdersInboxFill.QTYReceived')"
                            v-bind:TypeProp="'text'" 
                            v-bind:Name="'QTYReceived'"   
                            v-bind:isReadOnly="true"            
                            v-model="item.qtyReceived"               
                            v-bind:Id="'input_QTYReceived'+index">                                     
                        </MdEdit>
                    </b-col>
                    <b-col lg="2" md="2" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrdersInboxFill.ExpDate')"
                            v-bind:TypeProp="'text'" 
                            v-bind:Name="'ExpDate'"   
                            v-bind:isReadOnly="true"            
                            v-model="item.expirationDate"               
                            v-bind:Id="'input_ExpDate'+index">                                     
                        </MdEdit>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('DrugOrdersInboxFill.Lot')"
                            v-bind:TypeProp="'text'" 
                            v-bind:Name="'Lot'"   
                            v-bind:isReadOnly="true"            
                            v-model="item.lotNo"               
                            v-bind:Id="'input_Lot'+index">                                     
                        </MdEdit>
                    </b-col>
                </b-row>
            </div>
        </div>



  </div>



  


<MdTitle v-bind:Text="$t('PatientClaimList.PatientInformation')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
   


        <div class="IncidentContainerBox noNum mt-2">            
            <div class="row">
            <div class="col-md-12">
                <div class="grid-margin stretch-card">
                <div class="card activeCard">
                    <div class="card-body">
                      <div class="d-flex align-items-start justify-content-between">
                          <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate">
                              {{patientInfo.patientName}} - {{PatientCode}} - {{ $t('Shared.Dob') }} {{patientInfo.dob}} {{patientInfo.ageFormatted}} - {{$t('Shared.Weight') + label('Weightlbs')}} {{patientInfo.weight}} - {{$t('Shared.Height')+ label('Heightft')}} {{patientInfo.heights}}
                          </h6>
                          <b-button  v-on:click="DoReport()"  style="position: relative; top: -4px;" class="repDateNotesBtn mx-2"  v-b-tooltip.hover :title="$t('MdPatientInfoBox.CurrentFaceSheet')">
                              {{ $t('Shared.FS') }}
                          </b-button>
                      </div>


                    <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('modalMarsMed.clickTitleTextPatient')}}</small></b-collapse>
                    <b-collapse id="InfoBoxs"> 
                        


                        <div class="card activeCard">			
                            <div class="container-mars">
                                <div class="card-container">
                                    <div class="card-body">
                                        <div class="row patPhoto-container">
                                            <div class="col-md-1 patPhoto">

                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="patientInfo.allergies && !patientInfo.specialPrecautions && !patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+patientInfo.allergies" 
                                                    variant="primary">
                                                </i>

                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="!patientInfo.allergies && patientInfo.specialPrecautions && !patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.SPECIALPR')}: `+patientInfo.specialPrecautions" 
                                                    variant="primary">
                                                </i>

                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="!patientInfo.allergies && !patientInfo.specialPrecautions && patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.MarsAlerts')}: `+patientInfo.marsAlerts" 
                                                    variant="primary">
                                                </i>

                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="patientInfo.allergies && patientInfo.specialPrecautions && !patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+patientInfo.allergies + ` / ` + $t('RigthBar.SPECIALPR') +': '+ patientInfo.specialPrecautions" 
                                                    variant="primary">
                                                </i>
                                                
                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="patientInfo.allergies && !patientInfo.specialPrecautions && patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+patientInfo.allergies + ` / ` + $t('RigthBar.MarsAlerts') +': '+ patientInfo.marsAlerts" 
                                                    variant="primary">
                                                </i>


                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="!patientInfo.allergies && patientInfo.specialPrecautions && patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.SPECIALPR')}: `+patientInfo.specialPrecautions + ` / ` + $t('RigthBar.MarsAlerts') +': '+ patientInfo.marsAlerts" 
                                                    variant="primary">
                                                </i>

                                                <i 
                                                    id="rm-allergic" 
                                                    v-if="patientInfo.allergies && patientInfo.specialPrecautions && patientInfo.marsAlerts" 
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+patientInfo.allergies + ' / '+   `${$t('RigthBar.SPECIALPR')}: `+patientInfo.specialPrecautions + ` / ` + $t('RigthBar.MarsAlerts') +': '+ PhotoObj.marsAlerts" 
                                                    variant="primary">
                                                </i>

                                                <img v-if="patientInfo.contents" v-bind:src="'data:image/'+'.'+patientInfo.extension+';base64,'+patientInfo.contents" alt="Foto" class="patPic img-fluid" style="height: 100%;">                                               
                                                
                                                <img v-else-if="(patientInfo.contents === null || patientInfo.contents === '') && patientInfo.sex === 'F'" src="@/assets/images/faces/nopic-female.jpg" alt="Foto" class="photo img-fluid">                                                
                                              
                                                <img v-else src="@/assets/images/faces/nopic-male.jpg" alt="Foto" class="photo img-fluid">
                                            </div>
                                            <div class="col-md-11">
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.PatientName') }}</small><br>
                                                        <b>{{patientInfo.patientName}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.PatientCode') }}</small><br>
                                                        <b>{{PatientCode}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Dob') }}</small><br>
                                                        <b>{{patientInfo.dob}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Age') }}</small><br>
                                                        <b>{{patientInfo.ageFormatted}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Gender') }}</small><br>
                                                        <b>{{patientInfo.sex}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('Shared.Weight')+ label('Weightlbs')}}</small><br>
                                                        <b>{{patientInfo.weight}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('Shared.Height')+ label('Heightft')}}</small><br>
                                                        <b>{{patientInfo.heights}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$tc('Shared.Program')}}</small><br>
                                                        <b>{{medications.programName}}</b>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                </div>
                            </div>    
                        </div>
                        


                        <div class="row mt-2"> 
                            <MdPatientAllergies v-if="PatientCode"
                                v-bind:NoUseClass="false"               
                                v-bind:ModalIdAddAllergy="'AddAllergyMars'"
                                v-bind:VisibleAllergy="true"                    
                                v-bind:UseColumnDinamic="true"
                                v-bind:Column="'col-md-3'"                   
                                v-bind:PatientCode="PatientCode.trim()"
                                v-bind:NoValidateChanges="true">						
                            </MdPatientAllergies> 
                            <MdPatientSpecialPrecautions	v-if="PatientCode"
                                v-bind:NoUseClass="false"                
                                v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMarsMed'"                   
                                v-bind:VisibleSpecialPrecautions="true"
                                v-bind:UseColumnDinamic="true"
                                v-bind:Column="'col-md-3'"
                                v-bind:PatientCode="PatientCode.trim()"
                                v-bind:NoValidateChanges="true">						
                            </MdPatientSpecialPrecautions> 
                            <MdPatientMarsAlert v-if="PatientCode"
                                v-bind:UseColumnDynamic="true"
                                v-bind:ModalIdAddMarksAlert="'ModalMarsAlert'"
                                v-bind:VisibleMarsAlert="true"
                                v-bind:Column="'col-md-3'"					
                                v-bind:PatientCode="PatientCode.trim()">						
                            </MdPatientMarsAlert>
                            <MdPatientDiagnosis v-if="PatientCode"
                                v-bind:UseColumnDinamic="true"
                                v-bind:VisibleDiagnosis="true"
                                v-bind:ModalIdDiagnosis="'ModalIdDiagMarsMed'"
                                v-bind:Column="'col-md-3'"
                                v-bind:PatientCode="PatientCode.trim()">						
                            </MdPatientDiagnosis>
                        </div>               
                </b-collapse>
                    </div> 
                </div>                
                </div>                 
            </div>                     
            </div>                
        </div>


       <MdTitle v-bind:Text="$t('Medication.PatMedications')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

           <div class="IncidentContainerBox noNum mt-2">            
            <div class="row">
            <div class="col-md-12">
                <div class="grid-margin stretch-card">
                <div class="card activeCard">
                    <div class="card-body">
                    <div class="d-flex align-items-start justify-content-between">
                        <h6 v-b-toggle="'InfoMed'" class="card-title flex-grow lower-line text-truncate">
                           {{$t('DrugOrdersInbox.ViewAllMed')}}
                        </h6>
                    </div>
                    <b-collapse visible id="InfoMed" class="small-info ml-2"><small>{{$t('modalMarsMed.clickTitleTextPatient')}}</small></b-collapse>
                    <b-collapse id="InfoMed"> 
                        <div class="card activeCard">			
                            <div class="container-mars">
                                <div class="card-container">
                                    <div class="card-body">
                                             <b-row>
             <div class="col-sm-12 col-md-3">  
                <MdSelect
                  v-bind:Label="$t('Medication.RxStatus')"
                  v-bind:Options="RxStatusList"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Model="ModelRxStatus"
                  v-bind:Multiple="false"              
                  :Input="ChangeDropDownRxStatus"                 
                  v-bind:Name="'rxstatus_select'"
                  id="rxtatus_select"
                  />
              </div>
            <div class="col-sm-12 col-md-9 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                  <input 
                    type="text" 
                    class="form-control"
                    :dir="dirInput"
                    v-model="parameter.SearchCriteria"   
                    @keyup.enter="getPatientMedications2(medications.patientCode)">
  
                  <div class="input-group-append">
                    <MdButton 
                      v-bind:Name="'btnsearchinput'"
                      v-bind:VariantProp="'btn btn-sm search-attached'"
                      v-bind:IconClass="'mdi mdi-magnify'"
                      v-on:click="getPatientMedications2(medications.patientCode)">
                    </MdButton>
                  </div>
                </div>
              </div>
            </div>
        </b-row>
        <div class="row">
                <div class="col-md-12">           
                    <MdTable 
                    v-bind:fields="fields2"
                    v-bind:items="items2"
                    v-bind:totalRows="totalRows2"   
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage2"
                    v-bind:perPage="perPage2"
                    v-bind:IsMedicationList="true"
                    :viewIconEvent="ViewMed"
                    v-bind:pageOptions="pageOptions2"
                    :onFiltered="onFiltered2"
                    :pageChanged="pageChanged2"
                    :onRowSelected="onRowSelected2"
                    :otherIcon="'printer-fill'"
                    :otherIconEvent="ShowReport"
                    :RowClick="RowClicked"   
                    :perPageFunction="PerPageFunction2">
                    </MdTable>  
                </div>
        </div>               
                                    </div>
                                </div>
                            </div>    
                        </div>
                                    
                </b-collapse>
                    </div> 
                </div>                
                </div>                 
            </div>                     
            </div>                
        </div>

    

     <PatientMedicationsRep v-if="isReportVisible" 
            :closeWindow="closeParamRepWindow"
            :patientCode="this.PatientCode"
            :recNo="recNoToReport"
        />   



    <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="posSelected === 0"
            v-bind:Label="'◄'"
            v-bind:Name="'btnBackRec'" 
            v-bind:VariantProp="'light'"
            v-bind:TextToolTip="$t('DrugOrdersInbox.BackRecordId')"           
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"
        />

          {{ShowText}}

        <MdButton
            v-bind:isReadOnly="posSelected === recordsId.length-1"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnNextRec'"
            v-bind:TextToolTip="$t('DrugOrdersInbox.NextRecordId')" 
            v-bind:VariantProp="'light'"
            v-bind:ClassProp="'mx-2'"
        />  

        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:Name="'btnBack'"
            v-bind:TextToolTip="$t('Shared.Back')" 
            v-on:click="goBack"
            v-bind:ClassProp="'mx-2 btn-login'"
        />       
        
        <b-button-group variant="primary" v-if="medications">
            <b-button :disabled="isReadOnly || getSumQtyReturn()" variant="primary" v-on:click="processHandler()"> {{$t('DrugOrdersInbox.ReturnedItems')}} </b-button>
              <b-dropdown variant="primary" class="ms-2" id="dropdown-buttons">                
                  <b-dropdown-item-button v-if="medications.internalStatus === 'PENDING'" v-on:click="SetStatusHandler('ORDERED')" :disabled="false"> {{$t('DrugOrdersInboxRightBar.Settoordered')}} </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="this.medications.internalStatus === 'FILLED' || this.medications.internalStatus === 'PARTIALFILLED'" v-on:click="undoFillOrders" :disabled="false"> {{$t('DrugOrdersInboxRightBar.Undofillorders')}} </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="!ValidateNoChargeable() &&  ValidateVoided()" v-on:click="updateChargeable('CHARGEABLE')" :disabled="false"> {{$t('DrugOrdersInboxRightBar.SetToChargeable')}} </b-dropdown-item-button>
                  <b-dropdown-item-button :disabled="false" v-on:click="getUrlDrugInfo"> {{$t('DrugOrdersInboxFill.DrugInfo')}} </b-dropdown-item-button>                  
                  <b-dropdown-item-button v-if="!medications.isPatientOwnMedication && medications.internalStatus && ( medications.internalStatus.toUpperCase() === 'PENDING' || medications.internalStatus.toUpperCase() === 'ORDERED')" :disabled="false" v-on:click="SetStatusHandler('UNABLETOFILL')"> {{$t('DrugOrdersInboxFill.UnableToFill')}} </b-dropdown-item-button>
                  <b-dropdown-item-button :disabled="false" v-on:click="AddingNotes">{{$t('DrugOrdersInboxFill.PharmacyNotes')}} </b-dropdown-item-button>
                  <b-dropdown-item-button  v-if="medications.internalStatus && (medications.internalStatus.toUpperCase() === 'FILLED' || medications.internalStatus.toUpperCase() === 'PARTIALLYFILLED')" :disabled="false" v-on:click="OpenMedLabel()">{{$t('DrugOrdersInboxRightBar.Printmedlabels')}}</b-dropdown-item-button> 
                  <b-dropdown-item-button :disabled="false" v-on:click="Print"> {{$t('Shared.Report')}} </b-dropdown-item-button>                 
              </b-dropdown>
        </b-button-group>
        
      
        
        </div>

        <ModalDrugOrderMedication
          v-if="VisibleModalViewMed"
          :RecordId="RecordId" 
          :PatientCode="PatientCode"
          :isControlledSubstance="isControlledSubstance"
          :isUAE="isNRC"         
          @Print="Print"
          :TitleWindow="$t('DrugOrdersInboxFill.MedicationInfo')"        
          @OnModalDrugOrderInboxClose="CloseModalMed"          
          ModalId="'ModalIdModalViewMedValid'"
        >
        </ModalDrugOrderMedication>

        <DrugOrderNotesDlg
          :visible="addNoteVisible"
          :item="addNoteItem"
          @close="closeHandler"
          @ok="okHandler"
          @ret:comments="setStatusUnableToFillHandler"
          :editable="pharmacyNoteEditable"
        >
        </DrugOrderNotesDlg>

        <MDTextEditorDialog
          :visible="textEditorVisible"
          v-model="textEditorValue"
          @close="closeTextEditorHandler"
          @ok="okTextEditorHandler"
          :handlerOk="undoFillOrdersAsync"
          :required="true"
        >
        </MDTextEditorDialog>

        <DxPopup
            :visible="isReportPatientMedicationVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('PatientMedications.ReportMedications')"
            @hidden="onHiddenMedicationReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"            
            @showing="onShowing"
            :wrapper-attr="popupAttributes"
          >
            <ReportViewer
              ref="patientMedications"
              :ReportName="'PatientMedications'"
              :ReportTitle="$t('PatientMedications.ReportMedications')"
              :IsAnAPIReport="true"
            />
        </DxPopup>

         <MedicationLabelsRep v-if="isMedicationLabelsRepVisible"
          :closeWindow="closeParamRepWindowMedLabel" 
          :codeList="this.recordIdSelected"
        />


        <DxPopup 
            :visible="isReportPatientFaceSheetVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="reportTitle"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
          >
            <ReportViewer
            ref="PatientFaceSheetRep"
            :ReportName="'PatientFaceSheet'"
            :ReportTitle="reportTitle"
            :IsAnAPIReport="true"
            />
          </DxPopup>
           
  </div>
</template>

<script>
import Utils from '@/common/utils'
import ShowMessage from '@/components/messages/ShowMessage.js'
import Permission from '@/common/Permission'
import MedicationService from '@/services/medication.service'
import DocumentManagementService from '@/services/documentmanagement.service'
import PatientService from '@/services/patient.service'
import DrugOrderService from '@/services/drugordersinbox.service'
import EnumService from "@/services/enum.service"
import PharmacyOptions from '@/services/pharmacyoption.service'
import { DxPopup } from 'devextreme-vue/popup';
import DrugOrderNotesDlg from './DrugOrderNotesDlg'
import { EventBus } from '@/event-bus.js';
import ModalDrugOrderMedication from '@/components/pages/drugordersinbox/modalDrugOrderViewMedication';


export default {
  name: 'DrugOrdersReturnedItems',
  mixins: [ShowMessage, Utils, Permission],
  components: { ModalDrugOrderMedication,DxPopup,DrugOrderNotesDlg },

  data(){
    return{ 
      textEditorVisible: false,
      textEditorValue: '',
      isNRC:this.$store.state.companies.isNRC,
      MessageNoFillOrder:null,
      isMedicationLabelsRepVisible: false,
      TitleCondition:"",
      isControlledSubstance:"",
      TotalQtyToFill:0,
      CanReturnedItem:true,
      unitSys: this.$store.state.companies.UnitSystem ? this.$store.state.companies.UnitSystem : 'U',
      CanCallHeader:false,
    //  isReadOnly:this.$store.state.isDrugInboxFillEHRReadOnly,
      ReadOnlyByConditions:false,
      VisibleModalViewMed:false,  
      reportTitle: this.$t('MdPatientInfoBox.PatientFaceSheet'),
      isReportPatientFaceSheetVisible: false,
      isReportPatientMedicationVisible: false,
      recordsId: [],
      pendingChanges: false,
      addNoteItem: null,
      pharmacyNoteEditable: true,
      addNoteVisible: false,
      showEmptyRecords:false,
      PharmacyOption:{},
      LocationList:[],
      ModelLocation:{code:"",name:""},
      ShowText:"",
      posSelected:0,
      recordIdSelected:"",
       RxStatusList:EnumService.ClinicalMedicatiosRxStatus,
       ModelRxStatus: {value:'ActiveDuration',name: this.$t('MedisList.ActiveDuration')},
      OrderDetail:[],
      InfoHeader:{},
      recNoToReport: '',
      PatientCode: '',
       PhotoObj:{patientPhoto:"",patientPhotoExtension:"",dob:null,patientName:"",sex:"",marsAlerts:"",},
      patientPhoto: '',
      medications: {},
      patientInfo: {contents:null,sex:"",extension:""},
      parameter:{
          SearchCriteria:'',                           
        },

        emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },

       OptionsRightMenu:{
            visible:false,
            btnvisible:false,
           // patientCode:this.medications.patientCode,
            ItemsList:[],
            favButtonAtion: false
        },
      
      items2: [],
      fields2: [
          { key: 'startDateTime', sortable: true, label: this.$t('MedisList.StartDate'), class: 'text-rigth' },    
          { key: 'endDateTime', sortable: true, label: this.$t('MedisList.EndDate'), class: 'text-rigth' },    
          { key: 'recordId', sortable: true, label: 'RecordId', class: 'hidden' },
          { key: 'day', sortable: true, label:this.$t('MedisList.Days'), class: 'text-rigth' },       
          { key: 'drugName', sortable: true, label:this.$t('Medication.DrugName'), class: 'text-rigth' },       
          { key: 'activeIngredients', sortable: true, label:this.$t('Shared.activeIngredients'), class: 'text-rigth' },       
          { key: 'sig', sortable: true, label: this.$t('MedisList.Sig'), class: 'text-rigth'},       
          { key: 'prescriber', sortable: true, label:this.$t('MedisList.Prescriber'), class: 'text-rigth' }, 
          //{ key: 'rxStatus', sortable: true, label: this.$t('Medication.RxStatus'), class: 'text-rigth' }, 
          { key: 'internalStatus', sortable: true, label:this.$t('MedisList.InternalStatus'), class: 'text-rigth' }, 
          //{ key: 'quantityOrdered', sortable: true, label: this.$t('MedisList.TotalQuantity'), class: 'text-rigth' },      
          { key: 'stopDateTime', sortable: true, label:this.$t('Medication.StopDate'), class: 'text-rigth' }
        ],
      totalRows2: 0,
      currentPage2: 1,
      perPage2: 10,
      pageOptions2: [5, 10, 15,20,30,40,50],
      params2 : {
        PatientCode: ''
      },

      items: [],
      totalRows: 0,
      ShowMessageIsEmpty:false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15,20,30,40,50],
      selected: [],
      indexSelected: 0,
      FieldsDateArr:['issuedDate'], 
      isReportVisible: false,
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',     
    }
  },

computed: {
        isReadOnly() {
            const status = this.medications.internalStatus;
             if (status === undefined || status === null || !status) return false;
            const enabled = (status === 'FILLED' || status === 'RECEIVED' || status === 'MARSCREATED' || status === 'PARTIALLYGIVEN');            
            return this.$store.state.isDrugInboxReturnedItemsEHRReadOnly || !enabled;
        } 
    },

  methods:{

    getSumQtyReturn(){    
      let result = 0;
      this.OrderDetail.forEach(element => {
        result+=element.qtyToReturn;
      });
      return result <= 0;
    },

    CheckFilledAndReturn(){
      for (const element of this.OrderDetail) {
         if(element.qtyToReturn > element.qtyFilled){
          return false;
        }        
      }
      return true;
    },



    closeTextEditorHandler() {
        this.textEditorVisible = false;
        this.textEditorValue = '';
    },

    okTextEditorHandler() {
        this.textEditorVisible = false;
        this.textEditorValue = '';
    },

    undoFillOrders() {
      this.$bvModal
        .msgBoxConfirm(this.$t('DrugOrdersInbox.UndoFillOrdersMsg2'), {
          title: this.$t('DrugOrdersInboxRightBar.Undofillorders'),
          okTitle: this.$t('DrugOrdersInbox.TitleUndoFillOrder'),
          cancelTitle: this.$t('Shared.BtnCancel'),
          footerClass: "p-2",
          titleClass: "modal-title modal-type-warning",
        })
        .then((value) => {
          if (value) {
            this.$bvModal
              .msgBoxConfirm(this.$t('DrugOrdersInbox.ConfirmAddNoteMsg'), {
                title: this.$t('DrugOrdersInboxRightBar.Undofillorders'),
                okTitle: this.$t('Shared.TitleYes'),
                cancelTitle: this.$t('Shared.TitleNo'),
                footerClass: "p-2",
                titleClass: "modal-title modal-type-warning",
              })
              .then((value) => {
                if (value) {
                  this.textEditorValue = '';
                  this.textEditorVisible = true;
                } else {
                  this.undoFillOrdersAsync('');
                }
              });
          }
        });
      },

      undoFillOrdersAsync(note) {
        let params = {
          "recordIds": [],
          "notes": ""
        }       

        params.recordIds.push(this.recordIdSelected.trim());    

        params.notes = note
        this.setUndoOrders(params)
      },

      setUndoOrders(data) {
        DrugOrderService.undoOrders(data)
          .then((response) => {
            if(response.status == '200'){                       
              setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);   
              
              this.loadFirstItem(this.recordIdSelected);
            }               
          })
          .catch((error) => {
            this.showResponseErrorMessage(error);
          });
      },


    getRecordId() {
      let recordIdList = [];    
      recordIdList.push(this.recordIdSelected);
      return recordIdList;
    },

    OpenMedLabel(){
      this.isMedicationLabelsRepVisible = true;
    },

    closeParamRepWindowMedLabel() {
     this.isMedicationLabelsRepVisible = false;
    },

    processHandler() {

      if(!this.getSumQtyReturn() && this.CheckFilledAndReturn()){

            const items = this.OrderDetail
                .filter(item => item.qtyToReturn > 0)
                .map((item) => {
                    return {
                        itemNo: item.recNo,
                        qtyToReturn: item.qtyToReturn,
                        qtyFilled : item.qtyFilled,
                        remarks: item.remarks
                    }
                });

            const data = {
                items: items,
                recordId: this.recordIdSelected
            }           
            DrugOrderService
                .setReturnedItems(data)
                .then((response) => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        Promise.all([                            
                            this.searchItems(this.recordIdSelected,this.ModelLocation.code),
                        ]);

                        if(this.posSelected === this.recordsId.length-1){
                          this.$router.push({ name: 'DrugOrdersInbox'});                                 
                        }                        
                        
                        if(this.posSelected < this.recordsId.length-1){
                          this.Next();       
                        }

                        this.MessageSuccess();                             
                      

                    }
                })
                .catch((error) => {  
                    this.showResponseErrorMessage(error);
                });

              }
        },

        MessageSuccess(){
              setTimeout(() => 
                  this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                      title: this.$t('Msg.Success'),
                      autoHideDelay: 5000,
                      variant: "success"
                  }) , 50
              );     
        },

    UpdateFiledToGive(qtyToFill,qtyAvailable,Id){
        let arr = this.OrderDetail;
        let total = 0;
        arr.forEach(function(item) {
            total+=item.qtyToFill;                          
        });
         if( (qtyToFill <= this.TotalQtyToGive) && (qtyToFill <= qtyAvailable)){
            this.FilledToGive = total; 
         }else{
            document.getElementById(Id).focus();
         }        
    },

    setFocus(Id){
         document.getElementById(Id).focus();
    },

    setValue(Id,val){
      document.getElementById(Id).value = val;
    },

    UpdateFilled(){
      this.TotalQtyToFill = 0;
      let arr = this.OrderDetail;
        let total = 0;
        arr.forEach(function(item) {
            total+=item.qtyToFill;                          
        });

        this.TotalQtyToFill = total;

    },


    onChangeReturnQTY(Id,item){
       if(item.qtyToReturn < 0){
          this.setFocus(Id);
          item.qtyToReturn = 0;  
          this.showMessage(this.$tc('Msg.Error'),this.$t('DrugOrdersInbox.ReturnQty'),"error");
          return;
        }

         if(item.qtyToReturn > item.qtyFilled){
            this.setFocus(Id);
             item.qtyToReturn = 0; 
           // item.qtyToReturn = qtyFilled;  
            this.showMessage(this.$tc('Msg.Error'),this.$t('DrugOrdersInbox.QuantityReturnExceeds'),"error");
            return;
        }   
    },
    
/*
 blurQTYToReturn(qtyToReturn,qtyFilled,Id){       

        if(qtyToReturn > qtyFilled){
            this.setFocus(Id);
           // item.qtyToReturn = qtyFilled;  
            this.showMessage(this.$tc('Msg.Error'),this.$t('DrugOrdersInbox.QuantityReturnExceeds'),"error");
            return;
        }    
    },  */  

    okHandler() {
        this.addNoteVisible = false;
    },

    closeHandler() {
        this.addNoteVisible = false;
    },

    setStatusUnableToFillHandler(pharmacistNotes) {
      let params = {
          "recordIds": [],
          "status": "",
          "pharmacistNotes": ""
        }
        params.status = 'UNABLETOFILL';   
        params.recordIds.push(this.recordIdSelected);
        params.pharmacistNotes = pharmacistNotes;
        this.setStatus(params);
    },

    AddingNotes() {     
        this.pharmacyNoteEditable = true;
        this.addNoteItem = {recordId:this.recordIdSelected};
        this.addNoteVisible = true;      
    },

    updateChargeable(status) { 
        let params = {
          "recordIds": [],
          "chargeable": status === status
        }                 
        params.recordIds.push(this.recordIdSelected); 
        this.updateChargeableAsync(params);               
      },

      updateChargeableAsync(data) {
        DrugOrderService.UpdateChargeable(data)
          .then((response) => {
            if(response.status == '200'){                       
              setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);   
            }               
          })
          .catch((error) => {            
            this.showResponseErrorMessage(error);
          });
  },

   getUrlDrugInfo(){        
       MedicationService.getUrlDrugInfo(this.medications.drugCode)
            .then((response) => {      
               if (response.status == '200' && response.data) {
                    window.open(response.data.url, '_blank');      
               }               
         })
         .catch(error => {            
            this.showResponseErrorMessage(error);                
         });    
    },    

    SetStatusHandler(status) {      
      if (status == 'UNABLETOFILL') {
        this.pharmacyNoteEditable = false;
        this.addNoteItem = {recordId:this.recordIdSelected};
        this.addNoteVisible = true;
      } else {
        let params = {
          "recordIds": [],
          "status": "",
          "pharmacistNotes": ""
        }
        params.status = status; 
        params.recordIds.push(this.recordIdSelected);
        this.setStatus(params);
      }
    },

    ValidateState(state){   
     return this.medications.internalStatus?.toUpperCase() === state.toUpperCase();       
    },

    ValidateRxStatus(status) {   
         return this.medications.rxStatus?.toUpperCase() === status.toUpperCase();  
    }, 

    PatientOwnMedication(){      
       return this.medications.isPatientOwnMedication;        
    },





     setStatus(data) {         
      DrugOrderService.UpdateStatus(data)
        .then(async (response) => {
          if(response.status == '200'){  
            if(data.recordIds.length === response.data.affectedRows){
                setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);
            }else{
                 setTimeout(() => 
              this.$bvToast.toast(response.data.affectedRows +" "+this.$t('MdGenericOutCome.OutOf')+" "+data.recordIds.length+" "+this.$t('DrugOrdersInbox.ItemsAffected'), {
              title:this.$tc('Msg.Warning', 1),
              autoHideDelay: 5000,
              variant: "warning"
            }), 50);
            }         
            
            this.updatesCall();  

          }                              
        })
        .catch((error) => {         
          this.showResponseErrorMessage(error);
        });
    },

     popupAttributes(){

    },

    ValidateNoChargeable(){
      return this.medications.chargeable;      
    },

    ValidateVoided(){
        return this.medications.internalStatus?.toUpperCase() !== "VOIDED";  
    },

     onHiddenMedicationReport() {
      this.isReportPatientMedicationVisible = false;
    },
    


    onShowing(e) {
      let contentElement = e.component.content();
      let titleElement = e.component._$title[0];
      contentElement.style.padding = '0px';
      titleElement.style.padding = '0px 20px';
    },

    onHiddenReport() {
      this.isReportPatientFaceSheetVisible = false;
    },

    closeParamRepWindow() {
        this.isReportVisible = false;
        this.recNoToReport = '';
    },

   async Back(){
          if(this.posSelected > 0){
            this.posSelected-=1;          
            this.recordIdSelected = this.recordsId[this.posSelected];
            this.ShowText = this.$t('Shared.Showing')+ " "+(this.posSelected+1)+" "+this.$t('Shared.Of')+" "+this.recordsId.length;
            await this.loadFirstItem(this.recordsId[this.posSelected]);
        }
    },

    async Next(){      
        if(this.posSelected <= this.recordsId.length-1){
            this.posSelected+=1;
            this.recordIdSelected = this.recordsId[this.posSelected];
            this.ShowText = this.$t('Shared.Showing')+ " "+(this.posSelected+1)+" "+this.$t('Shared.Of')+" "+this.recordsId.length;
            await this.loadFirstItem(this.recordsId[this.posSelected]);
        }
    },

    goBack() {
        this.$router.push({ name: 'DrugOrdersInbox' });
    },

    Fill(){
     this.FillOrder();
    },

    GotoMedByBox(){
      this.RecordId = this.recordIdSelected;
      this.VisibleModalViewMed = true;
    },

    ViewMed(item){
      this.RecordId = item.recordId;
      //this.PatientCode = item.patientCode ? item.patientCode.trim():null;
      this.VisibleModalViewMed = true;
    },

    CloseModalMed(){
       this.VisibleModalViewMed = false;
    },

    Print() {
      let reportParams = [];    
      reportParams.push({ paramName: 'patientCode', paramValue: this.PatientCode ?? null });
      reportParams.push({ paramName: 'recNo', paramValue: this.recordIdSelected ?? null });
      reportParams.push({ paramName: 'isControlledSubstance', paramValue: this.medications.drugTypeCode ?? null });
      reportParams.push({ paramName: 'isUAE', paramValue:this.isNRC });
      this.isReportPatientMedicationVisible = true;
      this.$refs.patientMedications.buildDocument(reportParams);
    },

    DoReport() {
		let reportParams = [];

    reportParams.push({ paramName: 'PatientCodeList', paramValue: this.PatientCode});
		reportParams.push({ paramName: 'ActivePatient', paramValue: ''});
    reportParams.push({ paramName: 'ActiveAdmission', paramValue: ''});
        
    this.isReportPatientFaceSheetVisible = true;
    this.$refs.PatientFaceSheetRep.buildDocument(reportParams);
	},
   
    
    ChangeDropDownRxStatus(v){
        this.ModelRxStatus = v !== null ? v : {value:"All",name:this.$t('Shared.All')};
        this.getPatientMedications2(this.medications.patientCode);
    },

    onFiltered2(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    onRowSelected(item) {
      this.selected = item;
    },

    onRowSelected2(item) {
      this.selected = item;
    },

    RowClicked(){

    },

    pageChanged2(page) {            
      this.currentPage = page;    
    },

    pageChanged(page) {            
      this.currentPage = page;    
    },

    PerPageFunction(perpage){
      this.perPage = perpage;  
      this.currentPage = 1;
    },

    PerPageFunction2(perpage){
      this.perPage = perpage;  
      this.currentPage = 1;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },


    ChangeDropDownLocation(item){  
            this.ModelLocation = item ? item : {code:"",name:""};  
            Promise.all([                
                this.searchItems(this.recordIdSelected,this.ModelLocation.code),
            ]);
        },

      label(value) {
            if (value === 'Temperature' ) {
                return this.unitSys === 'U' ? ' (°F)' :  ' (°C)';
            }

            if (value === 'Weightlbs') {
                return this.unitSys === 'U' ? ' (lbs)' :  ' (Kgs)';
            }

            if (value === 'Weightoz') {
                return this.unitSys === 'U' ? ' (oz)' :  ' (g)';
            }

            if (value === 'Heightft' || value === 'HeadCirin') {
                return this.unitSys === 'U' ? ' (ft)' :  ' (cm)';
            }

            if (value === 'Heightin') {
                return this.unitSys === 'U' ? ' (in)' :  ' (mm)';
            }

            if (value === 'SugarLevelmgdL') {
                return this.unitSys === 'U' ? ' (mg/dL)' :  ' (mM)';
            }

            if (value === 'BMIlbsin2') {
                return this.unitSys === 'U' ? ' (lbs/in2)' :  ' (kgs/m2)';
            }

            return '';
        },


    ShowReport(item) {
        if(item){
          if (item && item.recordId) {
            this.recNoToReport = item.recordId
          }
          this.isReportVisible = true
        } else {
          setTimeout(() => 
            this.$bvToast.toast(this.$t('MdTable.nRecShow'), {
              title:  this.$t('Msg.Info'),
              autoHideDelay: 3000,
              variant: "info"
            }),
          50);
        }
      },

    onRowClicked(item,index) {    
      this.indexSelected = index

      if(item.selected){      
        this.$set(item, 'selected', false);         
      }else{
        this.$set(item, 'selected', true);       
      }
    },

    async getPatientInfo(patientCode) {    
      await PatientService.get(patientCode)
        .then((response) => { 
        if(response.data){
          this.patientInfo = response.data;
          this.patientInfo.contents = this.patientPhoto.contents;
          this.patientInfo.extension = this.patientPhoto.extension;

          this.patientInfo.patientName = this.patientInfo.firstname + ' ' + this.patientInfo.lastname
          this.patientInfo.dob = Utils.formatterDateToString(this.patientInfo.dob);         
        }             
        })
        .catch((error) => {
          this.showResponseErrorMessage(error);
        });
    },   
    
    async CanFillOrder() {    
      await DrugOrderService.CanFillOrder(false,this.recordIdSelected)
        .then((response) => { 
        if(response.data){         
          this.CanFill = response.data.result;
          this.MessageNoFillOrder = response.data.message;
        }             
        })
        .catch((error) => {
          this.showResponseErrorMessage(error);
        });
    },   

    async getPatientPhoto(patientCode) {    
      await DocumentManagementService.GetPatientPhoto(patientCode)
        .then((response) => { 
        if(response.data){
          this.patientPhoto = response.data;         
        }             
        })
        .catch((error) => {         
          this.showResponseErrorMessage(error);
        });
    },    


     async getPatientMedications(id) {     
      await MedicationService.get(id)
        .then((response) => { 
        if(response.data){
          this.medications = response.data;  
          this.PatientCode = this.medications.patientCode; 
          this.isControlledSubstance = this.medications.drugTypeCode;      
        }             
        })
        .catch((error) => {         
          this.showResponseErrorMessage(error);
        });
    },

    getDescriptionByCode(arr,code){
      let description = "";
      if(arr.length > 0){
        for(var i = 0; i < arr.length; i++){
          if(arr[i].code && arr[i].code.trim() === code){
            description = arr[i].name;
            break;             
          }
        }
      }
      return description
    },

    IsLocationsinList(arr,code){     
      arr.forEach(element => {
        element.code = element.code?.trim();       
      });

     return arr.find(u => u.code.includes(code));
    },

     async getDrugOrderLocations() {    
      await DrugOrderService.getLocations()
        .then((response) => { 
        if(response.data){
            this.LocationList = response.data;  
            if(this.IsLocationsinList(this.LocationList,this.PharmacyOption.defaultLocation.toString())){
              this.ModelLocation.code = this.PharmacyOption.defaultLocation ? this.PharmacyOption.defaultLocation?.trim() : "";   
              this.ModelLocation.name = this.getDescriptionByCode(this.LocationList, this.PharmacyOption.defaultLocation); 
            }else{
             if(this.LocationList.length > 0){
               this.ModelLocation.code = this.LocationList[0].code?.trim();
               this.ModelLocation.name = this.LocationList[0].name?.trim();
             }
            }  
            
        }             
        })
        .catch((error) => {
          this.showResponseErrorMessage(error);
        });
    },
    
        searchItems(recordId, location) {
            DrugOrderService.getReturnedItems({recordId: recordId, location: location?.trim()})
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.pendingChanges = false;                     
                        this.OrderDetail = response.data.map((item) => {
                            return {
                                ...item,
                                'expirationDate': Utils.formatterDateToString(item.expirationDate),
                                'qtyToReturn': 0,
                                'remarks': '',
                            }
                        });

                        this.showEmptyRecords = this.OrderDetail.length === 0;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

    async getPharmacyOptions(){                       
         await PharmacyOptions.getPharmacyOptions()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){                
                        this.PharmacyOption = response.data[0];
                    }                    
                })
                .catch((error) => {  
                    this.showResponseErrorMessage(error);
                });        
        },

        async getPatientMedications2(patientCode) {
         var params2 = {
            PatientCode:patientCode,
            Status:this.ModelRxStatus.value,
            PageNumber:this.currentPage2,
            PageSize:this.perPage2,
            SearchCriteria:this.parameter.SearchCriteria ? this.parameter.SearchCriteria : ""
        }
        await MedicationService.getAll(params2)
        .then((response) => { 
        if(response.status == "200" && response.data){
          this.items2 = response.data;
           this.totalRows2 = this.items2.length > 0 ? this.items2[0].maxRows : 0;  
            this.items2.forEach(function(item) {
              if (item.startDateTime)	
                  item.startDateTime = Utils.formatterDateTimeToString(item.startDateTime);
              if (item.endDateTime)	
                  item.endDateTime = Utils.formatterDateTimeToString(item.endDateTime);
              if (item.stopDateTime)	
                  item.stopDateTime = Utils.formatterDateTimeToString(item.stopDateTime);
            });  
         if(this.items2.length === 0){
            this.ShowMessageIsEmpty = true;
          }          
        }                  
        })
        .catch((error) => {         
          this.showResponseErrorMessage(error);
        });
    },

     async CanReturnedItemOrder() {    
      await DrugOrderService.CanReturnedItemOrder(false,this.recordIdSelected)
        .then((response) => { 
        if(response.data){         
          this.CanReturnedItem = response.data.result;         
        }             
        })
        .catch((error) => {
          this.showResponseErrorMessage(error);
        });
    }, 

    async updatesCall(){
       await this.getPatientMedications(this.recordIdSelected);
       this.CanReturnedItemOrder();
    },

    async loadFirstItem(id) {
      this.CanReturnedItemOrder();
      this.getPharmacyOptions();      
      await this.getPatientMedications(id);
      this.searchItems(id,this.medications.location);  
      await this.getPatientPhoto(this.medications.patientCode); 
      await this.getPatientInfo(this.medications.patientCode);    
      await this.getPatientMedications2(this.medications.patientCode);
    },
  },
  
  async mounted() {
    this.OptionsRightMenu.visible = false;
    this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
    this.OptionsRightMenu.ItemsList = [];

    this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);

    let layoutStatus = this.$store.state.layoutStatus;
    switch(layoutStatus) {
      case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      case 'L1R0':
      case 'L1R1':
          this.OptionsRightMenu.btnvisible = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      default:
          this.OptionsRightMenu.favButtonAtion = true;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }   
  },

  async created() {  

     const stored = sessionStorage.getItem('DrugOrdersValidationRecordsId');
        this.posSelected = 0;

        if (stored) {
            this.recordsId = JSON.parse(stored);
            this.recordIdSelected = this.recordsId[0];
            this.ShowText = this.$t('Shared.Showing')+ " "+(this.posSelected+1)+" "+this.$t('Shared.Of')+" "+this.recordsId.length;           
            await this.loadFirstItem(this.recordsId[0]);
        }

        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed
        }.bind(this));
        window.addEventListener('beforeunload', this.beforeWindowUnload);  

  },
  
 
};
</script>
